import { graphql } from 'gatsby'
import React, { FC } from 'react'

import useSiteSettings from '../../../hooks/useSiteSettings'

interface FooterLegalFootnotesProps {
  isPrinting?: boolean
}

export const FooterLegalFootnotes: FC<FooterLegalFootnotesProps> = ({ isPrinting = false }) => {
  const { footerLegalFootnotes } = useSiteSettings() || {}

  return (
    <section aria-label="Footer Notes">
      {footerLegalFootnotes &&
        (isPrinting ? (
          <p className="text-[0.53125rem] leading-[1.5]">{footerLegalFootnotes.join(' ')}</p>
        ) : (
          footerLegalFootnotes.reduce((acc: React.ReactElement[], text, index) => {
            if (!text) return acc
            acc.push(
              <p className="text-xs mb-3" key={index}>
                {text}
              </p>,
            )
            return acc
          }, [])
        ))}
    </section>
  )
}

export const footerLegalMenu = graphql`
  fragment footerLegalFootnotesFragment on SanitySiteSettings {
    footerLegalFootnotes
  }
`
